
export default class BankAccountMemberResponseModel {
    public bankAccountMemberId: number = 0;
    public givenName: string = '';
    public surname: string = '';
    public roleType: string = '';
}
